import React from 'react';
import PropTypes from 'prop-types'

import './style.scss'

export const Overlay = ({ children, overlay, preventOverflow }) => {
    const trigger = React.Children.only(children);

    return (
        <div className='overlay_container'>
            {trigger}
            <div style={preventOverflow} className='overlay_popover'>
                {overlay}
            </div>
        </div>
    )
}
Overlay.propTypes = {
    overlay: PropTypes.node,
    children: PropTypes.node,
    preventOverflow: PropTypes.object
}
